var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Access_Point"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Access_Point",
    "data-name": "Access Point",
    clipPath: "url(#clip-Access_Point)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    transform: "translate(18.399 119.315)",
    fill: "#0c0b0b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.263.073,420.338,2.95a10.877,10.877,0,0,1,3.721.7,12.1,12.1,0,0,1,3.292,1.867,11.6,11.6,0,0,1,2.517,2.758,9.7,9.7,0,0,1,1.391,3.377L468.228,198.81a10.369,10.369,0,0,1,.013,4.12,8.573,8.573,0,0,1-1.516,3.409,7.961,7.961,0,0,1-2.791,2.343,8.8,8.8,0,0,1-3.807.92L11.514,219.082a11.288,11.288,0,0,1-4.452-.8,10.767,10.767,0,0,1-3.585-2.354,10.549,10.549,0,0,1-2.353-3.546,10.751,10.751,0,0,1-.763-4.37L6.692,9.124a8.376,8.376,0,0,1,.925-3.557,9.486,9.486,0,0,1,2.3-2.884A10.787,10.787,0,0,1,13.244.758,11.542,11.542,0,0,1,17.263.073Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 439.9141235351562 183.5884246826172 L 410.5103149414062 24.66854476928711 L 32.22230529785156 23.0903263092041 L 29.22173500061035 190.7829284667969 L 439.9141235351562 183.5884246826172 M 460.1264343261719 209.6026763916016 L 11.51432132720947 219.0816802978516 C 9.926563262939453 219.115234375 8.422174453735352 218.8293914794922 7.061865329742432 218.2838439941406 C 5.701831817626953 217.7383270263672 4.486594200134277 216.9335632324219 3.476402044296265 215.929443359375 C 2.466946601867676 214.9261016845703 1.662723422050476 213.7241973876953 1.123428344726562 212.3838043212891 C 0.5847628116607666 211.0449829101562 0.3106189072132111 209.5684967041016 0.3601028025150299 208.0142517089844 L 6.692170143127441 9.12440013885498 C 6.732450485229492 7.859204769134521 7.059857368469238 6.65731954574585 7.616909980773926 5.56724739074707 C 8.173226356506348 4.478611469268799 8.958649635314941 3.501365661621094 9.916107177734375 2.683642387390137 C 10.87248134613037 1.866845965385437 12.00074100494385 1.20900559425354 13.2443323135376 0.7580488324165344 C 14.48690605163574 0.3074601590633392 15.84510231018066 0.06324439495801926 17.26287841796875 0.07336196303367615 L 420.3381042480469 2.949799537658691 C 421.6116638183594 2.958888053894043 422.8712463378906 3.208399295806885 424.0589904785156 3.651892185211182 C 425.2468566894531 4.095460414886475 426.3634033203125 4.733290672302246 427.3504943847656 5.519152164459229 C 428.3381652832031 6.305499076843262 429.1965637207031 7.240381717681885 429.8672485351562 8.277581214904785 C 430.5386047363281 9.315810203552246 431.0220947265625 10.45691204071045 431.2586059570312 11.65451526641846 L 468.2275390625 198.8098297119141 C 468.5146484375 200.2637329101562 468.5049743652344 201.6565246582031 468.2408142089844 202.9301910400391 C 467.976318359375 204.2056427001953 467.4568176269531 205.3615570068359 466.7252502441406 206.3395690917969 C 465.9927062988281 207.3187561035156 465.0477905273438 208.119384765625 463.9338684082031 208.682861328125 C 462.8189392089844 209.2467803955078 461.53515625 209.5729217529297 460.1264343261719 209.6026763916016 Z",
    stroke: "none",
    fill: "#443e3e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    transform: "translate(66 159)",
    fill: "#fff",
    stroke: "#0a0000",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 362,
    height: 132,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 358,
    height: 128,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wifi-svgrepo-com_2_",
    "data-name": "wifi-svgrepo-com (2)",
    d: "M79.2,16.8A57.466,57.466,0,0,0,61.182,4.494a54.076,54.076,0,0,0-43.164,0A57.468,57.468,0,0,0,0,16.8l6.918,7.551a47.834,47.834,0,0,1,14.7-9.94,45.064,45.064,0,0,1,35.971,0,47.83,47.83,0,0,1,14.7,9.94ZM65.361,31.906a38.2,38.2,0,0,0-11.373-7.578,36.051,36.051,0,0,0-28.776,0,38.206,38.206,0,0,0-11.373,7.578l6.93,7.564a28.58,28.58,0,0,1,8.04-5.224,27.036,27.036,0,0,1,21.582,0,28.588,28.588,0,0,1,8.04,5.224ZM28.631,48.053l9.7,10.583a1.7,1.7,0,0,0,2.546,0l9.7-10.583a14.65,14.65,0,0,0-4.955-3.978,13.544,13.544,0,0,0-12.028,0A14.652,14.652,0,0,0,28.631,48.053Z",
    transform: "translate(88.52 189.703)",
    fill: "#2416ef",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wifi-svgrepo-com_2_2",
    "data-name": "wifi-svgrepo-com (2)",
    d: "M104.469,21.113A76.06,76.06,0,0,0,80.7,5.647a74.579,74.579,0,0,0-56.936,0A76.063,76.063,0,0,0,0,21.113L9.125,30.6A63.35,63.35,0,0,1,28.511,18.111a62.15,62.15,0,0,1,47.447,0A63.344,63.344,0,0,1,95.344,30.6Z",
    transform: "translate(74.674 167.452)",
    fill: "#2416ef",
    stroke: "#707070",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Fast_Free",
    "data-name": "Fast & Free",
    transform: "translate(180 161)",
    fill: "#2416ef",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Fast &amp; Free")), /*#__PURE__*/React.createElement("text", {
    id: "RailWire_Wi-Fi",
    "data-name": "RailWire Wi-Fi",
    transform: "translate(212 190)",
    fill: "#2416ef",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "RailWire Wi-Fi")), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("text", {
    id: "e",
    transform: "translate(257 273) rotate(180)",
    fill: "#060606",
    fontSize: 36,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "e")), /*#__PURE__*/React.createElement("text", {
    id: "w",
    transform: "translate(236 237)",
    fill: "#060606",
    fontSize: 36,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "w")), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    y2: 19,
    transform: "translate(269.5 234.5)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 19,
    transform: "translate(269.5 258.5)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M273.428,234.5v18.262h17.487",
    fill: "none",
    stroke: "#040404",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M273.428,252.762V234.5h17.487",
    transform: "translate(0 25)",
    fill: "none",
    stroke: "#040404",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M273.428,234.5v18.262h17.487",
    transform: "matrix(-0.017, 1, -1, -0.017, 475.69, -33.246)",
    fill: "none",
    stroke: "#040404",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 43,
    transform: "translate(319.5 234.5)",
    fill: "none",
    stroke: "#040404",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    id: "e-2",
    "data-name": "e",
    transform: "translate(293 237)",
    fill: "#060606",
    fontSize: 36,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 39
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(42.945 207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wifi-svgrepo-com_2_3",
    "data-name": "wifi-svgrepo-com (2)",
    d: "M161.055,28.67A128.3,128.3,0,0,0,124.2,9.047,141.4,141.4,0,0,0,80.312,1.365,137.1,137.1,0,0,0,36.657,7.559,118.229,118.229,0,0,0,.43,25.941l14.223,11.9A98.743,98.743,0,0,1,44.206,23a114.249,114.249,0,0,1,36.379-5.162,117.844,117.844,0,0,1,36.572,6.4,107.1,107.1,0,0,1,30.061,15.855Z",
    transform: "matrix(-0.454, 0.891, -0.891, -0.454, 143.7, 132.503)",
    fill: "#443e3e",
    stroke: "#443e3e",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 0.174,
    y2: 177.5,
    transform: "translate(74.5 334.5)",
    fill: "none",
    stroke: "#443e3e",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(47.161 207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wifi-svgrepo-com_2_4",
    "data-name": "wifi-svgrepo-com (2)",
    d: "M188.961,45.524c-12.853-10.8-31.308-22.848-47.225-29.359A160.545,160.545,0,0,0,91.209,4.387,141.94,141.94,0,0,0,41.7,9.568,117.7,117.7,0,0,0,1.343,30.036l9.781,19.2c9.546-7.382,27.631-16.777,40.04-20.4A118.28,118.28,0,0,1,92.42,24.514a136.773,136.773,0,0,1,77.3,30.816l8.141-4.148Z",
    transform: "matrix(-0.454, 0.891, -0.891, -0.454, 169.055, 134.281)",
    fill: "#443e3e",
    stroke: "#443e3e",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(54.844 208.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wifi-svgrepo-com_2_5",
    "data-name": "wifi-svgrepo-com (2)",
    d: "M222.559,69.409C207.3,55.64,180.213,30.192,161.64,21.5A186.138,186.138,0,0,0,103.11,4.737,150.488,150.488,0,0,0,46.565,8.661,119.725,119.725,0,0,0,1.25,31.63L11.366,51.483c10.6-8.525,31.206-19.25,45.267-23.065,14.849-4.028,32.27-.975,48.835.873a155.123,155.123,0,0,1,48.776,13.97c15.106,7.069,35.588,25.365,48.067,36.465l9.8-4.992Z",
    transform: "matrix(-0.454, 0.891, -0.891, -0.454, 196.012, 136.496)",
    fill: "#443e3e",
    stroke: "#443e3e",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 2.174,
    y2: 190.5,
    transform: "translate(428.5 321.5)",
    fill: "none",
    stroke: "#443e3e",
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    transform: "translate(65 344)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    transform: "translate(65 368)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    transform: "translate(65 392)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    transform: "translate(65 416)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    transform: "translate(65 440)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    transform: "translate(65 464)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    transform: "translate(65 488)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    transform: "translate(420 344)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    transform: "translate(420 368)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    transform: "translate(420 392)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    transform: "translate(420 416)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    transform: "translate(420 440)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    transform: "translate(420 464)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    transform: "translate(420 488)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessPoint);
export default __webpack_public_path__ + "static/media/Access Point.7f20290d73bfbc6a4e796eacd367eb98.svg";
export { ForwardRef as ReactComponent };